import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Formik } from 'formik';

import { Button } from 'react-bootstrap';

import {
  validate,
  format,
  TextField,
  RoleField,
  LocationField,
  attachRefToFields,
} from '../Form';

class UserDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      user = {},
      locations = [],
    } = this.props;

    const {
      error = '',
    } = this.state;

    const roles = _.map(user.roles || [], r => r.role_id);
    const locs = _.map(user.locations || [], l => l.id);

    const fields = {
      first_name: '',
      last_name: '',
      email: '',
      ...user,
      roles,
      locations: locs,
    };

    console.log(error);

    return (
      <div className='detail'>
        <Formik
          initialValues={{
            ...fields,
          }}
          ref={(c) => { this.form = c; }}
          enableReinitialize
          validate={values => validate(this, values)}
          onSubmit={async (values, { setSubmitting, setErrors }) => { // eslint-disable-line
            let newValues = values;
            try {
              newValues = await format(this, values);
            } catch (err) {
              console.error(err); // eslint-disable-line
              this.setState({
                error: 'An unknown error occured',
              });
              return;
            }
            setSubmitting(true);
            let resp;
            try {
              resp = await this.props.update(newValues);
            } catch (err) {
              this.setState({
                error: err.message,
              });
            }
            setSubmitting(false);
            return resp;
          }}
          render={(props) => { // eslint-disable-line
            const page = this;
            return (
              <React.Fragment>
                <div className='title'>{`${user.first_name} ${user.last_name}`}</div>
                {error ? <div className='alert alert-danger'>{error}</div> : null}
                <form onSubmit={props.handleSubmit}>
                  <div className='form-group'>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='first_name'
                        label='First Name'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='last_name'
                        label='Last Name'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <RoleField
                        name='roles'
                        label='Roles'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                        handleChange={(event, role, remove = false) => {
                          console.log((event ? event.target.value : 'NO!'));
                          const roleId = role || parseInt(event.target.value, 10);
                          if (roleId < 0) return;
                          const form = this.form;
                          let newRoles = form.state.values.roles || [];
                          console.log(newRoles);
                          if (remove) {
                            newRoles = _.without(newRoles, roleId);
                          } else {
                            newRoles.push(roleId);
                          }
                          form.setFieldValue('roles', _.uniq(newRoles));
                        }}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='email'
                        label='Email'
                        required
                        validation={{
                          email: true,
                        }}
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row'>
                      <LocationField
                        name='locations'
                        label='Locations'
                        required
                        options={_.map([{ value: '', label: '' }].concat(locations), l => ({
                          value: l.id,
                          label: _.filter([l.city, l.state, l.country], f => f).join(', '),
                        }))}
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                        handleChange={(event, location, remove = false) => {
                          const locationId = location || event.target.value;
                          if (!locationId) return;
                          const form = this.form;
                          let newLocations = form.state.values.locations || [];
                          if (remove) {
                            newLocations = _.without(newLocations, locationId);
                          } else {
                            newLocations.push(locationId);
                          }
                          form.setFieldValue('locations', _.uniq(newLocations));
                        }}
                      />
                    </div>
                  </div>
                </form>
                <div className='actions'>
                  <span>
                    <Button bsStyle='danger' onClick={this.props.close}>
                      Revert
                    </Button>
                  </span>
                  <span>
                    <Button
                      bsStyle='primary'
                      onClick={() => {
                        props.validateForm();
                        props.submitForm();
                      }}
                    >
                      Save Changes
                    </Button>
                  </span>
                </div>
              </React.Fragment>
            );
          }}
        />
        <div className='footer-gradient' />
      </div>
    );
  }
}

UserDetail.propTypes = {
  user: PropTypes.shape({}),
  orgId: PropTypes.string,
  locations: PropTypes.instanceOf(Array),
  update: PropTypes.func.isRequired,
  close: PropTypes.func,
};

UserDetail.defaultProps = {
  user: {},
  orgId: '',
  locations: [],
  close: () => {},
};

export default UserDetail;



// WEBPACK FOOTER //
// ./src/views/Components/Detail/UserDetail.js